var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"attempts-table",attrs:{"hide-default-footer":"","no-data-text":_vm.$t('TEST.ATTEMPTS.no_attempts'),"headers":_vm.headersAttempts.map(function (h) { return (Object.assign({}, h,
      {text: _vm.$t('TEST.ATTEMPTS.HEADERS.' + h.text)})); }),"items":_vm.attempts},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.index + 1)+" ")]}},{key:"item.date",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.getDateSentence(item.date))+" ")]}},{key:"item.answers",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(item.answers.length)+"/"+_vm._s(item.questions.length)+" ")]}},{key:"item.score",fn:function(ref){
    var item = ref.item;
return [_c('span',{class:{
        'font-weight-medium': !item.score || item.score === 100,
        'green--text': item.score === 100,
        'red--text': !item.score
      }},[_vm._v(" "+_vm._s(item.score.toFixed(2))+"% ")])]}},{key:"item.timeTaken",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(item.timeTaken.hours)+"h "+_vm._s(item.timeTaken.minutes)+"m "+_vm._s(item.timeTaken.seconds)+"s ")]}},{key:"item.mode",fn:function(ref){
      var item = ref.item;
return [_vm._v(" "+_vm._s(_vm.$t("TEST.ATTEMPTS.MODE." + (item.mode || "undefined")))+" ")]}},{key:"item.result",fn:function(ref){
      var item = ref.item;
return [_c('span',{staticClass:"font-weight-medium",class:{
        'green--text': item.approved,
        'red--text': !item.approved
      }},[_vm._v(" "+_vm._s(_vm.$t("TEST.ATTEMPTS." + (item.approved ? "approved" : "failed")))+" ")])]}},{key:"item.review",fn:function(ref){
      var item = ref.item;
return [_c('v-btn',{attrs:{"text":"","small":"","color":"blue"},on:{"click":function($event){return _vm.reviewAttempt(item)}}},[_vm._v(" "+_vm._s(_vm.$t("TEST.ATTEMPTS.HEADERS.review"))+" ")])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }